import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";

const statusLabels = {
  0: "ร่าง",
  1: "รอเซ็น",
  2: "ใช้งาน",
  4: "เซ็นแล้ว",
  5: "ยกเลิก",
};

const statusColors = {
  0: "bg-gray-100 text-gray-600",
  1: "bg-yellow-100 text-yellow-700",
  2: "bg-green-100 text-green-700",
  4: "bg-blue-100 text-blue-700",
  5: "bg-red-100 text-red-600",
};

export default function QuoteContractsModal({
  isOpen,
  onClose,
  quote = null,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const contracts = quote?.CT_List || [];
  const canAddContract = Number(quote?.Doc_Status) === 2;

  if (!isOpen) return null;

  const handleViewContract = (c) => {
    const arId = quote?.AR_Id || "";
    const search = encodeURIComponent(c.CT_No || "");
    const backLink = `${location.pathname}${location.search || ""}`;
    navigate(
      arId ? `/contractlist/${arId}?search=${search}` : `/contractlist?search=${search}`,
      {
        state: {
          backLink,
          backLabel: "ใบเสนอราคา",
        },
      }
    );
    onClose();
  };

  const handleAddContract = () => {
    if (!quote?.Doc_Id || !quote?.AR_Id) return;
    navigate(`/contract/create?quote_id=${quote.Doc_Id}&ar_id=${quote.AR_Id}`);
    onClose();
  };

  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      style={{ display: isOpen ? "block" : "none", backgroundColor: "rgba(0,0,0,0.5)" }}
      tabIndex="-1"
      role="dialog"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content border-0 shadow-lg rounded-lg overflow-hidden">
          <div
            className="modal-header py-3"
            style={{ backgroundColor: "#E13F57", color: "white" }}
          >
            <h5 className="modal-title font-semibold">
              สัญญาของใบเสนอราคา {quote?.Doc_No || ""}
            </h5>
            <button
              type="button"
              className="close text-white opacity-100 hover:opacity-80 border-0 bg-transparent fs-3"
              onClick={onClose}
              aria-label="ปิด"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body p-0">
            <div className="table-responsive" style={{ maxHeight: "50vh", overflowY: "auto" }}>
              <table className="table table-bordered table-hover mb-0">
                <thead className="thead-light" style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: "#f8f9fa" }}>
                  <tr>
                    <th style={{ width: "80px" }}>ลำดับ</th>
                    <th>เลขที่สัญญา</th>
                    <th>สถานะ</th>
                  </tr>
                </thead>
                <tbody>
                  {contracts.length > 0 ? (
                    contracts.map((c, i) => (
                      <tr key={c.CT_Id || i}>
                        <td className="text-center">{i + 1}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-link p-0 text-primary text-decoration-none text-start"
                            onClick={() => handleViewContract(c)}
                          >
                            {c.CT_No || "-"}
                          </button>
                        </td>
                        <td>
                          <span
                            className={`px-2 py-1 rounded text-xs font-medium ${
                              statusColors[Number(c.CT_Status)] || "bg-gray-200 text-gray-600"
                            }`}
                          >
                            {statusLabels[Number(c.CT_Status)] ?? "ไม่ทราบ"}
                          </span>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center py-4 text-muted">
                        ยังไม่มีสัญญาจากใบเสนอราคานี้
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="p-3 border-top bg-light d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={onClose}
              >
                ปิด
              </button>
              {canAddContract && (
                <button
                  type="button"
                  className="btn text-white d-flex align-items-center gap-1"
                  style={{ backgroundColor: "#76D7C4" }}
                  onClick={handleAddContract}
                >
                  <Icon icon="mdi:plus-circle-outline" className="w-5 h-5" />
                  เพิ่มสัญญา
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
